// extracted by mini-css-extract-plugin
module.exports =  {"map":"sPJajez0mz3Hn7BkfrQN","marker":"RdgfdnJzcwbXgEUPWuzb"};